export default [{
    label: 'United States',
    value: 'USA'
  }, {
    label: 'Canada',
    value: 'Canada'
  }
];


// WEBPACK FOOTER //
// src/constants/countries.js